class FragranceQuiz {
  constructor() {
    this.currentStep = 1;
    this.totalSteps = 7;
    this.form = document.getElementById('fragranceQuizForm');
    this.steps = this.form.querySelectorAll('.quiz-step');
    this.prevBtn = this.form.querySelector('.prev-btn');
    this.nextBtn = this.form.querySelector('.next-btn');
    this.submitBtn = this.form.querySelector('.submit-btn');
    this.progressIndicator = document.querySelector('.progress-indicator');
    this.resultsContainer = this.form.querySelector('.quiz-results');
    
    this.initializeQuiz();
  }

  initializeQuiz() {
    this.updateProgress();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.prevBtn.addEventListener('click', () => this.navigateStep('prev'));
    this.nextBtn.addEventListener('click', () => this.navigateStep('next'));
    this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    
    // Enable next button when an option is selected
    this.steps.forEach(step => {
      const inputs = step.querySelectorAll('input[type="radio"]');
      inputs.forEach(input => {
        input.addEventListener('change', () => this.validateStep(this.currentStep));
      });
    });
    
    // Add event listener for restart button if it exists
    const restartBtn = document.querySelector('.restart-quiz-btn');
    if (restartBtn) {
      restartBtn.addEventListener('click', (e) => this.restartQuiz(e));
    }
  }

  navigateStep(direction) {
    if (direction === 'prev' && this.currentStep > 1) {
      this.currentStep--;
    } else if (direction === 'next' && this.currentStep < this.totalSteps) {
      if (this.validateStep(this.currentStep)) {
        this.currentStep++;
      } else {
        return;
      }
    }

    this.updateQuizDisplay();
  }

validateStep(step) {
  // Grab whatever element represents the current step
  const currentStep = this.form.querySelector(`[data-step="${step}"]`);

  /* ──────────────────────────
     STEP 7  ►  EMAIL REQUIRED
     ────────────────────────── */
  if (step === 7) {
    const emailInput = currentStep.querySelector('input[type="email"]');
    const email      = emailInput.value.trim();

    // quick-n-dirty RFC-style test
    const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    if (!validEmail) {
      alert('Please enter a valid email address');
      emailInput.focus();               // put cursor back in box
      return false;                     // stop navigation / submit
    }
    return true;                        // ✅ email looks good
  }

  /* ──────────────────────────
     STEPS 1-6  ►  RADIO CHECK
     ────────────────────────── */
  const selectedOption = currentStep.querySelector(
    'input[type="radio"]:checked'
  );

  if (!selectedOption) {
    alert('Please select an option to continue');
    return false;
  }

  return true;  // ✅ everything fine
}

  updateQuizDisplay() {
    this.steps.forEach(step => {
      step.style.display = 'none';
    });
    
    // Hide results container if it's visible
    this.resultsContainer.style.display = 'none';
    
    const currentStepElement = this.form.querySelector(`[data-step="${this.currentStep}"]`);
    currentStepElement.style.display = 'block';

    // Update navigation buttons
    this.prevBtn.disabled = this.currentStep === 1;
    this.prevBtn.style.display = 'block';
    
    if (this.currentStep === this.totalSteps) {
      this.nextBtn.style.display = 'none';
      this.submitBtn.style.display = 'block';
    } else {
      this.nextBtn.style.display = 'block';
      this.submitBtn.style.display = 'none';
    }

    this.updateProgress();
  }

  updateProgress() {
    const progress = (this.currentStep - 1) / (this.totalSteps - 1) * 100;
    this.progressIndicator.style.width = `${progress}%`;
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    if (!this.validateStep(this.currentStep)) {
      return;
    }

    // Show loading spinner if it exists
    const loadingSpinner = document.querySelector('.loading-spinner');
    if (loadingSpinner) {
      loadingSpinner.style.display = 'block';
    }

    const formData = new FormData(this.form);
    
    // Handle both naming conventions (q1, q2... or type, scent...)
    const jsonData = {
      email: formData.get('email'),
      type: formData.get('type') || formData.get('q1'),
      scent: formData.get('scent') || formData.get('q2'),
      intensity: formData.get('intensity') || formData.get('q3'),
      natural: formData.get('natural') || formData.get('q4'),
      feel: formData.get('feel') || formData.get('q5'),
      mood: formData.get('mood') || formData.get('q6')
    };

    try {
      const response = await fetch('https://fragrance-finder-quiz-genebenneth.replit.app/api/recommendations', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(jsonData)
      });

      // Hide loading spinner
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const recommendations_data = await response.json();
      const recommendations = recommendations_data.recommendations;
      this.displayResults(recommendations);
    } catch (error) {
      console.error('Error fetching recommendations:', error);
      
      // Hide loading spinner
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }
      
      const recommendationsContainer = document.getElementById('recommendations-container');
      recommendationsContainer.innerHTML = `
        <div class="quiz-error">
          <p>An error occurred while getting your recommendations. Please try again later.</p>
        </div>
      `;
      
      // Show results container with error
      this.steps.forEach(step => step.style.display = 'none');
      this.prevBtn.style.display = 'none';
      this.nextBtn.style.display = 'none';
      this.submitBtn.style.display = 'none';
      this.resultsContainer.style.display = 'block';
      
      // Make absolutely sure the loading spinner is hidden
      if (loadingSpinner) {
        loadingSpinner.style.display = 'none';
      }
    }
  }

  displayResults(recommendations) {
    // Hide all quiz steps
    this.steps.forEach(step => {
      step.style.display = 'none';
    });
    
    // Hide navigation buttons
    this.prevBtn.style.display = 'none';
    this.nextBtn.style.display = 'none';
    this.submitBtn.style.display = 'none';
    
    // Show results container
    this.resultsContainer.style.display = 'block';
    
    // Make sure loading spinner is hidden
    const loadingSpinner = document.querySelector('.loading-spinner');
    if (loadingSpinner) {
      loadingSpinner.style.display = 'none';
    }
    
    // Render recommendations
    const recommendationsContainer = document.getElementById('recommendations-container');
    recommendationsContainer.innerHTML = '';
    
    if (recommendations.length === 0) {
      const noResultsText = document.querySelector('[data-no-results-text]') ? 
        document.querySelector('[data-no-results-text]').textContent : 
        'No matching fragrances found. Please try different preferences.';
        
      recommendationsContainer.innerHTML = `<p>${noResultsText}</p>`;
    } else {
      recommendations.forEach(fragrance => {
        const fragranceCard = document.createElement('div');
        fragranceCard.className = 'fragrance-card';
        
        const viewProductText = document.querySelector('[data-view-product-text]') ? 
          document.querySelector('[data-view-product-text]').textContent : 
          'View Product';
          
        fragranceCard.innerHTML = `
            <h3>${fragrance.name}</h3>

            <!-- 3-line description -->
            <p class="fragrance-description">
            ${fragrance.description}
            </p>

              <!-- little black “tag” boxes -->
          <div class="fragrance-tags">
              <span class="tag">${fragrance.type}</span>
              <span class="tag">${fragrance.scent}</span>
              <span class="tag">${fragrance.intensity}</span>
              <span class="tag">${fragrance.mood}</span>
          </div>
          <div>
          <a href="/collections/${this.slugify(fragrance.name)}" class="view-product-btn" target="_blank">${fragrance.name}</a>
          </div>
        `;
        recommendationsContainer.appendChild(fragranceCard);
        // 🛑 Hide header + progress once we show recommendations
        document.querySelector('.quiz-title')?.classList.add('hidden');
        document.querySelector('.progress-indicator')?.classList.add('hidden');   // or hide .progress-bar if you prefer

      });
    }
    
    // Add restart button if it doesn't already exist
    if (!this.resultsContainer.querySelector('.restart-quiz-btn')) {
      const restartText = document.querySelector('[data-restart-quiz-text]') ? 
        document.querySelector('[data-restart-quiz-text]').textContent : 
        'Restart Quiz';
        
      const restartBtn = document.createElement('button');
      restartBtn.className = 'restart-quiz-btn';
      restartBtn.textContent = restartText;
      restartBtn.addEventListener('click', (e) => this.restartQuiz(e));
      
      this.resultsContainer.appendChild(restartBtn);
    }
  }
  
  restartQuiz(e) {
    if (e) e.preventDefault();

    // 🔄 Bring header + progress bar back
    document.querySelector('.quiz-title')?.classList.remove('hidden');
    document.querySelector('.progress-indicator')?.classList.remove('hidden');

    
    // Reset all form inputs
    this.form.reset();
    
    // Reset to first step
    this.currentStep = 1;
    
    // Hide results container
    this.resultsContainer.style.display = 'none';
    
    // Update the quiz display
    this.updateQuizDisplay();
  }
  
 slugify(text) {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}
}

// Initialize the quiz when the DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  // Check if the quiz form exists on the page
  if (document.getElementById('fragranceQuizForm')) {
    new FragranceQuiz();
  }
});